import { render, staticRenderFns } from "./sup-responsible-gaming.vue?vue&type=template&id=c84d2512"
import script from "./sup-responsible-gaming.vue?vue&type=script&lang=js"
export * from "./sup-responsible-gaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports